<script setup lang="ts">
/**
 * **节点头部上由类型声明的动作按钮**（2027 加）。
 *
 * 用户原话：
 *
 * > 然后是 js 代码节点，可以给增加一个按钮（静音按钮旁，跳转打开属性面板），
 * > **需要所有节点都支持在节点 header 添加按钮**，而不是只为 js 代码节点
 * > 添加这个功能，需要抽象到节点层次
 *
 * ## 拆成独立组件的理由
 *
 * 和六种行形态一样：`NpNodeHeader.vue` 已经贴着"行组件不超过 200 行"那条线，
 * 而这一块**自成一体**（一段 v-for + 往上报一个 id），拆出来两边都更好读。
 *
 * ## 它只做两件事
 *
 * ```text
 *   把类型声明的按钮画出来（图标 + 悬停说明）
 *   点一下把 **id** 往上抛 —— "这个 id 干什么"是宿主的事
 * ```
 *
 * ⚠️ 组件里**不认识**任何具体动作：在这儿写 `if (id === 'settings')` 就等于
 * 把"抽象到节点层次"这件事又收回去了（宿主那边也有一份实现，两处会分叉）。
 */
import type { NodeActionDef } from '../../node/package'

defineProps<{
  /** 这个类型声明的动作（空 / 省略 = 一个按钮都不画） */
  actions?: readonly NodeActionDef[]
}>()

const emit = defineEmits<{ (e: 'action', id: string): void }>()
</script>

<template>
  <button
    v-for="action in actions ?? []"
    :key="action.id"
    class="np-node__act nodrag"
    type="button"
    :title="action.label"
    :data-np-node-action="action.id"
    @pointerdown.stop
    @click.stop="emit('action', action.id)"
  >
    <!-- ⚠️ 同 `NpNodeHeader.vue`：`icon` 是 **SVG 内部标记**，必须 `v-html` -->
    <svg viewBox="0 0 24 24" aria-hidden="true" v-html="action.icon" />
  </button>
</template>
